<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialog" width="50%" height="50%">
      
      <div style="background-color: white; height: 100%; width: 100%;">
        <div style="background-color: red; height: 10%; width: 100%;" class="text-center">
          <p style="color: white;" class="text-h6"> Erro </p>
        </div>
        <p style="margin-left: 20px;">
          Limite de itens para impressão atingido, tente novamente com menos itens.
        </p>
        <!-- <template v-slot:actions> -->
          <div class="text-center" style="padding-bottom: 10px;">
            <v-btn class="ms-auto center" style="background-color: #c5c5c5" @click="dialog = false">Fechar</v-btn>
          </div>
          
        <!-- </template> -->
      </div>
        
      
    </v-dialog>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de operações em lotes
    </div>

    <v-card>
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!--<v-col cols="12" md="6" >
            <v-autocomplete
              v-model="cultureIds"
              label="Cultura(s)"
              :items="filtersList ? filtersList.accountContext.allCultures : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="cultureIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>         
          -->
          <!-- <v-col cols="12" md="6">
            <v-autocomplete v-model="productIds" label="Produto(s)"
              :items="filtersList ? filtersList.accountContext.productsInSales : []" item-value="id" item-text="name"
              clearable @click:clear="productIds = []" :loading="loadingFilters" multiple chips dense deletable-chips
              hint="Se nenhum produto for selecionado, todos serão exibidos" persistent-hint />
          </v-col> -->

          <v-col cols="12" md="12">
            <v-autocomplete v-model="itemLotNumbersIds" label="Lote(s)"
              :items="filtersList ? filtersList.accountContext.salesLotNumbers.itemLotNumbers : []" item-value="id"
              item-text="name" clearable @click:clear="itemLotNumbersIds = []" :loading="loadingFilters" multiple chips
              dense deletable-chips hint="Selecione ao menos um lote" persistent-hint />
          </v-col>

          <v-col cols="6" md="3">
            <v-switch v-model="withOperation" inset :label="withOperation ? 'Com operações' : 'Sem operações'">
            </v-switch>
          </v-col>

          <v-col cols="6" md="3">
            <v-autocomplete v-model="periodFilterModel" label="Período" :items="periodFilterOptions" item-value="key"
              item-text="name" />
          </v-col>
          <v-col cols="12" md="3" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField :inputData.sync="periodFilterRangeModel" label="Período Customizado" :hasTodayDate="true" />
          </v-col>

          <v-col cols="6" md="3">
            <v-btn class="mt-3" @click="runFilter(false)" :disabled="disableFilter()">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <!-- <BasePrint printableElementId="salesByProductsReportPrintTable" printButtonLabel="Imprimir"
        printTitle="Operações em lotes" @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false" class="mt-3" @printError="printError" /> -->

        <BasePrintPdf
          :pdfTitle="modelNamePlural"
          @pdf-open-action="(f) => loadPdf(f)"
          ref="nfePdfRef"
        />
    </div>

    <div id="salesByProductsReportPrintTable" v-if="salesByProductAnalyticReport" class="mt-5">

      <v-col cols="12">

        <v-row cols="pa-2 ma-2">
          <!-- <v-col cols="12"> -->
          <!-- <v-row> -->
            <v-col>
            <v-card-text class="text-h6">
              Data
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text class="text-h6">
              Operação
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text class="text-h6">
              Variedade
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text class="text-h6">
              Lote
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <p class="text-h6">Estufa</p>
            </v-card-text>
          </v-col>

          <v-col cols="12">
          <v-divider :thickness="5"></v-divider>
        </v-col>
          
          <!-- </v-row> -->
          <!-- </v-col> -->
        </v-row>

      </v-col>

      <v-row cols="pa-2 ma-2" v-for="(item, index) in salesByProductAnalyticReport" v-bind:data="item"
        v-bind:key="item.id">
        <v-col cols="pa-2 ma-2">
          <v-row>
            <v-col>
              <v-card-text>
                {{ item.operationDate }}
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-text>
                {{ item.operationTypeName }}
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-text>
                {{ item.varietyName }}
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-text>
                {{ item.nameWithOperation }}
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-text>
                {{ item.storageName }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>
        
        <v-col cols="12">
          <v-row v-for="(item2, index) in item.movementItems" v-bind:data="item2" v-bind:key="item2.name">
            <v-col>
              <v-card-text>
                {{ item2.name }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-divider :thickness="5"></v-divider>
        </v-col>

      </v-row>





      <!-- <v-col cols="12">
          <BaseIndex
            ref="baseIndex"
            v-if="salesByProductAnalyticReport"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="salesByProductAnalyticReport"
            :maskFields="maskFields"
            :enableCustomFilters="false"
            :containTopToolbar="false"
            :itemsPerPage="-1"
            :disablePagination="true"
            :indexNested="true"
            :hasDefaultPageTitle="false"
          >                    

          </BaseIndex>
        </v-col>    -->

    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";
import BasePrintPdf from '@shared_components/base_print_pdf.vue';
import { printError } from 'graphql';

export default {
  data() {
    return {
      loading: false,
      loadingFilters: false,
      pageLoading: false,
      monthFilter: moment().format('YYYY-MM'),
      itemLotNumbersIds: [],
      cultureIds: [],
      clientIds: [],
      productIds: [],
      salesByProductAnalyticReport: null,
      startDate: null,
      dialog: false,

      items: [
        { 'name': 'algo', 'quantity': 50, 'items': [{ name: "teste", quantity: 10 }] },
        { 'name': 'algo2', 'quantity': 100, items: [{ name: "teste", quantity: 10 }] }
      ]

      ,

      endDate: null,
      filtersList: null,
      withOperation: true,
      tableHeaders: [
        { text: "Estufa", align: "left", sortable: false, value: "storageName" },
        { text: "Produto", align: "left", sortable: false, value: "varietyName" },
        { text: "Lote", align: "left", sortable: false, value: "nameWithOperation" },
        { text: "Operação", align: "left", sortable: false, value: "operationTypeName" },
        { text: "Data da operação", align: "left", sortable: false, value: "operationDate" },
      ],
      maskFields: [
        { field: 'quantity', mask: 'number' },
        { field: 'unitPrice', mask: 'currency' },
        { field: 'price', mask: 'currency' },
        { field: 'operationDate', mask: 'date' },
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      periodFilterOptions: [
        { "key": null, "name": "Sem filtro de data" },
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: null,
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    }
  },
  props: {
    enabledLot: {
      type: Boolean,
      default: true,
    },
    headers: {
      type: Array,
      default: Array.new,
    },
    modelNamePlural:{
      type: String,
      default: "Relatório de operações em lotes"
    }
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
    BasePrintPdf: BasePrintPdf,
  },
  created() {
    this.loadServerFilters();
  },
  mounted() {
    // console.log("aa", this.tableHeaders);
    // this.tableHeaders.pop();
  },
  methods: {
    loadPdf: function(f){
      console.log('loadpdf');
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PDF,     
          variables: {
            cultureIds: this.cultureIds,
            clientIds: this.clientIds,
            productIds: this.productIds,
            startDate: this.startDate,
            endDate: this.endDate,
            itemLotNumbersIds: this.itemLotNumbersIds,
            withOperation: this.withOperation,
          },     
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.pdf = response.data.accountContext.lotOperationsReportPdf.pdf;
          this.numPages = response.data.accountContext.lotOperationsReportPdf.numPages;
          // console.log('num pages index', this.numPages);
          var obj = {pdf: this.pdf, numPages: this.numPages };
          // obj.numPages = this.numPages;
          // obj.pdf = this.pdf;
          // console.log('pdf', this.pdf);
          f(obj);          
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
        
        // return {pdf: this.pdf, numPages: this.numPages};
    },
    loadServerFilters: function () {
      this.loadingFilters = true;
      this.$apollo
        .query({
          query: LOAD_FILTERS_QUERY,          
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.filtersList = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingFilters = false));
    },
    loadServerEntries: function (firstLoading = false) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALES_PRODUCTS_BY_CUSTOMER_QUERY,
          variables: {
            cultureIds: this.cultureIds,
            clientIds: this.clientIds,
            productIds: this.productIds,
            startDate: this.startDate,
            endDate: this.endDate,
            itemLotNumbersIds: this.itemLotNumbersIds,
            withOperation: this.withOperation,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.salesByProductAnalyticReport = response.data.accountContext.lotOperationsReport;
          // console.log("this.salesByProductAnalyticReport", this.salesByProductAnalyticReport);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    disableFilter: function(){      
      if (this.itemLotNumbersIds && this.itemLotNumbersIds.length == 0){        
        return true;
      }
      else{
        return false;
      }
    },
    runFilter: function (firstLoading = false) {
      if (this.periodFilterModel == null) {
        this.startDate = null;
        this.endDate   = null;
      } else if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate = this.periodFilterRangeModel[1];
        }
      }
      // console.log(this.startDate, this.endDate);
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
    printError: function(){
      console.log("print error");
      this.dialog=true;
    },
  }
};

const LOAD_FILTERS_QUERY = gql`
  {
    accountContext {
      allCultures {
        id
        name
      }
      allCustomers {
        id
        name
      }
      productsInSales {
        id
        name
      }
      salesLotNumbers
    }
  }
`;

const LOAD_PDF = gql`
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $cultureIds: [ID!]!, $clientIds: [ID!]!, $productIds: [ID!]!, $withOperation: Boolean, $itemLotNumbersIds: [ID!]) {
  accountContext {
    lotOperationsReportPdf(cultureIds: $cultureIds, clientIds: $clientIds, productIds: $productIds, startDate: $startDate, endDate: $endDate, withOperation: $withOperation, itemLotNumbersIds: $itemLotNumbersIds)
  }
}
`;

const LOAD_SALES_PRODUCTS_BY_CUSTOMER_QUERY = gql`
query ($startDate: ISO8601Date, $endDate: ISO8601Date, $cultureIds: [ID!]!, $clientIds: [ID!]!, $productIds: [ID!]!, $withOperation: Boolean, $itemLotNumbersIds: [ID!]) {
  accountContext {
    lotOperationsReport(cultureIds: $cultureIds, clientIds: $clientIds, productIds: $productIds, startDate: $startDate, endDate: $endDate, withOperation: $withOperation, itemLotNumbersIds: $itemLotNumbersIds)
  }
}
`;

</script>

<style scoped>
.background {
  background: #c5c5c5;
}
.dialog{
  background-color: #ffffff !important; 
  height: 50% !important; 
  width: 50% !important;
}
</style>
